import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=56763bb3&scoped=true&"
import script from "./setup.vue?vue&type=script&lang=js&"
export * from "./setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56763bb3",
  null
  
)

export default component.exports